import {
  SEND_MESSAGE,
  SEND_MESSAGE_SUCCESS,
  SEND_MESSAGE_FAIL,
  UPDATE_DEFAULT_MESSAGE_REQUEST,
  UPDATE_WEBHOOK,
  INCREASE_REQUEST_NUMBER,
  DECREASE_REQUEST_NUMBER,
  UPDATE_TEST_MODE,
} from './constants';

export const sendMessage = (data) => ({
  type: SEND_MESSAGE,
  data,
});

export const sendMessageSuccess = (data) => ({
  type: SEND_MESSAGE_SUCCESS,
  data,
});

export const sendMessageFail = (err) => ({
  type: SEND_MESSAGE_FAIL,
  err,
});

export const updateDefaultMessageRequest = (data) => ({
  type: UPDATE_DEFAULT_MESSAGE_REQUEST,
  data,
});

export const updateWebhook = (data) => ({
  type: UPDATE_WEBHOOK,
  data,
});

export const increaseRequestNumber = () => ({
  type: INCREASE_REQUEST_NUMBER,
});

export const decreaseRequestNumber = () => ({
  type: DECREASE_REQUEST_NUMBER,
});
export const updateTestMode = (data) => ({
  type: UPDATE_TEST_MODE,
  data,
});
